import React from 'react';
import './styles.css';

const PageNav = ({ children }) => <div className="page-nav">{children}</div>;

export default PageNav;



// WEBPACK FOOTER //
// ./src/components/PageNav/index.js